<template>
    <div class="form">
        <Form ref="info" :label-width="140" :model="info" :rules="ruleValidate">
            <Row :gutter="20">
                <Col span="6">
                    <FormItem label="水电欠费自动断电" prop="autoBreakMeter ">
                        <i-switch
                            v-model="info.autoBreakMeter"
                            :true-value="1"
                            :false-value="0"
                        />
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem
                        label="水电欠费自动断水"
                        prop="waterTurnoffOnBalance"
                    >
                        <i-switch
                            v-model="info.waterTurnoffOnBalance"
                            :true-value="1"
                            :false-value="0"
                        />
                    </FormItem>
                </Col>
                <Col
                    span="10"
                    v-if="
                        info.autoBreakMeter === 1 ||
                        info.waterTurnoffOnBalance === 1
                    "
                >
                    <FormItem label="低于" prop="minAmount ">
                        <Input v-model="info.minAmount" :maxlength="100">
                            <span slot="append">元</span>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="6">
                    <FormItem label="房租欠费自动断电" prop="autoBreakRent  ">
                        <i-switch
                            v-model="info.autoBreakRent"
                            :true-value="1"
                            :false-value="0"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="6">
                    <FormItem
                        label="房租欠费自动断水"
                        prop="waterTurnoffOnRent"
                    >
                        <i-switch
                            v-model="info.waterTurnoffOnRent"
                            :true-value="1"
                            :false-value="0"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem prop="list" label="水电单价">
                        <add-meter
                            :value="info.list"
                            :meterTypeDict="dict.meterType"
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import { smartmeterSetting, smartmeterView } from '@/api/setting-meter'

import { currency, deepCopy } from '_u/helper.js'

import AddMeter from '_vc/fields/add-meter'
const clog = console.log
export default {
    name: 'c-meter-form',
    props: {
        houseIds: {
            type: [String, Number],
            default: '',
        },
    },
    components: { AddMeter },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                houseIds: this.houseIds,
                autoBreakMeter: 0,
                minAmount: 0,
                autoBreakRent: 0,
                waterTurnoffOnBalance: 0,
                waterTurnoffOnRent: 0,
                list: [],
            },
            dict: {
                meterType: this.$dict.NULL,
            },
        }
    },
    methods: {
        fetch() {
            const list = this.houseIds.split(',')
            if (list.length === 1) {
                return smartmeterView(this.houseIds)
            } else {
                return Promise.resolve()
            }
        },
    },
    computed: {
        ruleValidate() {
            return {
                // meterName: [{ required: true, message: '表名称必填' }],
                // meterType: [{ required: true, message: '表类型必填' }],
                // price: [{ required: true, message: '单价必填' }],
            }
        },
    },
    mounted() {
        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch(), this.$dict.get(['meter_type'])])
                .then((args) => {
                    const [view, dictGroup] = args

                    Object.assign(this.dict, dictGroup)

                    const entity = view?.data?.entity
                    const list = view?.data?.list
                    if (entity) {
                        // autoBreakRent 默认值为null，转换为0
                        entity.autoBreakRent = entity.autoBreakRent || 0
                        entity.autoBreakMeter = entity.autoBreakMeter || 0
                        Object.keys(this.info).forEach((name) => {
                            this.info[name] = entity[name]
                            this.info.minAmount = (
                                entity.minAmount / 100
                            ).toFixed(2)
                        })
                        this.info.houseIds = entity.houseId
                    }
                    if (list) {
                        list.forEach((v) => (v.price /= 100))
                        this.info.list = list
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            this.$refs.info
                .validate()
                .then(() => {
                    const data = deepCopy(this.$refs.info.populateData())
                    const info = deepCopy(this.info)
                    clog(info)
                    data.list.forEach((v) => {
                        v.price = (v.price * 100).toFixed(0)
                        v.meterTypeCode = this.dict.meterType.keyOf(
                            v.deviceMeterType
                        )
                    })
                    const list = JSON.stringify(data.list)
                    const formData = Object.assign(info, { list })
                    formData.minAmount = (formData.minAmount * 100).toFixed(0)
                    return smartmeterSetting(formData)
                })
                .then((res) => {
                    this.$Message.success('设置成功')
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>

<style lang="scss" scoped></style>
